import { render, staticRenderFns } from "./StatisticsIcon.vue?vue&type=template&id=25b53542"
import script from "./StatisticsIcon.vue?vue&type=script&lang=js"
export * from "./StatisticsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports